import { render, staticRenderFns } from "./article3.vue?vue&type=template&id=f2c63db2&scoped=true"
import script from "./article3.vue?vue&type=script&lang=js"
export * from "./article3.vue?vue&type=script&lang=js"
import style0 from "./article3.vue?vue&type=style&index=0&id=f2c63db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c63db2",
  null
  
)

export default component.exports